import React, { Component } from 'react';
import classNames from 'classnames';
import RadioGroup from './RadioGroup.js';
import Label from './Label.js';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { i as infoIconStyles } from '../InfoIcon-8b47be0d.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/InfoIcon.js';

var css_248z = "._0unYc{display:block}[dir] ._0unYc{margin-bottom:9px}.G-npr{align-items:center;color:var(--ricos-fallback-color,#000);display:flex}.G-npr label{align-items:center;display:inline-flex}.G-npr span{vertical-align:text-bottom}.LOSea label{width:50%}[dir=ltr] .cPs4L label+label{margin-left:36px}[dir=rtl] .cPs4L label+label{margin-right:36px}.S3J4Q{opacity:.5;pointer-events:none}";
var styles = {"radioGroupHorizontal_title":"_0unYc","radioGroupHorizontal_group":"G-npr","radioGroupHorizontal_groupTwoColumns":"LOSea","radioGroupHorizontal_groupInline":"cPs4L","radioGroupHorizontal_readOnly":"S3J4Q"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class RadioGroupHorizontal extends Component {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.id = `h_group_${Math.floor(Math.random() * 9999)}`;
  }
  render() {
    const _a = this.props, { label, inline, tooltipTextKey, t } = _a, props = __objRest(_a, ["label", "inline", "tooltipTextKey", "t"]);
    const { styles: styles2 } = this;
    const groupClassName = classNames(
      styles2.radioGroupHorizontal_group,
      inline && styles2.radioGroupHorizontal_groupInline,
      !inline && styles2.radioGroupHorizontal_groupTwoColumns
    );
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: infoIconStyles.infoContainer }, label && /* @__PURE__ */ React.createElement(Label, { label, tooltipText: t == null ? void 0 : t(tooltipTextKey) })), /* @__PURE__ */ React.createElement(RadioGroup, __spreadProps(__spreadValues({ ariaLabelledBy: `${this.id}_label` }, props), { className: groupClassName })));
  }
}

export { RadioGroupHorizontal as default };
//# sourceMappingURL=RadioGroupHorizontal.js.map
